module.exports = __webpack_public_path__ + "img/kefu.f7cee99b.jpg";